import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/PostedjobListing.css";
import { FiPlus, FiMoreVertical, FiEye, FiArrowLeft } from "react-icons/fi";
import { fetchMyJobs } from "../services/jobsApi";

// Seed data – used ONLY when no jobs exist in localStorage yet
{/*const seedJobs = [
  {
    id: 1,
    title: "Business Consultant, SaaS & Training Delivery",
    jobTitle: "Business Consultant, SaaS & Training Delivery",
    type: "Project",
    jobType: "Project",
    location: "Remote",
    company: "McKinsey & Company",
    companyName: "McKinsey & Company",
    status: "under_review",
    category: "published",
    createdAt: "2022-04-13T00:00:00.000Z",
    views: 18,
    applicants: 4,
  },
  {
    id: 2,
    title: "Senior Software Engineer (Back End) | Data Applications",
    jobTitle: "Senior Software Engineer (Back End) | Data Applications",
    type: "Project",
    jobType: "Project",
    location: "Remote",
    company: "McKinsey & Company",
    companyName: "McKinsey & Company",
    status: "expired",
    category: "published",
    createdAt: "2022-04-13T00:00:00.000Z",
    views: 24,
    applicants: 10,
  },
];*/}

const TABS = [
  { id: "all", label: "All Postings" },
  { id: "drafts", label: "Drafts" },
  { id: "archived", label: "Archive" },
];

const PAGE_SIZE = 4;

const PostedjobListing = () => {
  const [jobs, setJobs] = useState([]);
  const [activeTab, setActiveTab] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const [openMenuId, setOpenMenuId] = useState(null);

  const navigate = useNavigate();

  // Load jobs from localStorage. If empty, seed with sample jobs once.
  {/*useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("postedJobs") || "[]");

    if (!stored || stored.length === 0) {
      localStorage.setItem("postedJobs", JSON.stringify(seedJobs));
      setJobs(seedJobs);
    } else {
      setJobs(stored);
    }
  }, []);*/}

  //added on 27-11-2025
  useEffect(() => {
  async function loadJobs() {
    try {
      const data = await fetchMyJobs();
      setJobs(data);
    } catch (err) {
      console.error("Failed to load posted jobs", err);
    }
  }
  loadJobs();
}, []);

  // helper to persist
  const persist = (nextJobs) => {
    setJobs(nextJobs);
    localStorage.setItem("postedJobs", JSON.stringify(nextJobs));
  };

  const handleAddNew = () => {
    localStorage.removeItem("editJobFormData");
    localStorage.removeItem("editMode");
    navigate("/post-job");
  };

  const handleView = (job) => {
    localStorage.setItem("viewJob", JSON.stringify(job));
    navigate("/job-preview");
  };

  const handleEdit = (job) => {
    localStorage.setItem("editJobFormData", JSON.stringify(job));
    localStorage.setItem("editMode", "true");
    navigate("/post-job");
  };

  const handleReuse = (job) => {
    const draft = { ...job };
    delete draft.id;
    localStorage.setItem("jobDraftData", JSON.stringify(draft));
    localStorage.removeItem("editJobFormData");
    localStorage.removeItem("editMode");
    navigate("/recruiter-dashboard");
  };

  const handleDelete = (id) => {
    if (!window.confirm("Are you sure you want to delete this job posting?")) return;
    const updated = jobs.filter((job) => job.id !== id);
    persist(updated);
  };

  const handleArchive = (id) => {
    const updated = jobs.map((job) =>
      job.id === id ? { ...job, category: "archived" } : job
    );
    persist(updated);
  };

  const handleRestore = (id) => {
    const updated = jobs.map((job) =>
      job.id === id ? { ...job, category: "published" } : job
    );
    persist(updated);
  };

  const handleViewApplicants = (job) => {
    // store selected job so applicants page can show header etc.
    localStorage.setItem("selectedJobForApplicants", JSON.stringify(job));
    //navigate(`/applicants`);
    navigate(`/applicants/${job.job_id || job.id}`);
  };



  // filtering by tab
  const filteredJobs = jobs.filter((job) => {
    if (activeTab === "drafts") return job.category === "draft";
    if (activeTab === "archived") return job.category === "archived";
    return true;
  });

  // pagination
  const totalPages =
    filteredJobs.length === 0 ? 1 : Math.ceil(filteredJobs.length / PAGE_SIZE);

  const pageSafe = Math.min(currentPage, totalPages);
  const startIndex = (pageSafe - 1) * PAGE_SIZE;
  const displayJobs = filteredJobs.slice(startIndex, startIndex + PAGE_SIZE);

  const changeTab = (tabId) => {
    setActiveTab(tabId);
    setCurrentPage(1);
  };

  const handleChangePage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  return (
    <div className="joblist-container">
      {/* Header */}
      <div className="joblist-header">
        <div>
          <button
            className="icon-btn"
            title="Back"
            onClick={() => navigate(-1)}
          >
            <FiArrowLeft />
          </button>
          <p className="breadcrumb">Dashboard / Manage Postings</p>
          <h2>Manage Postings</h2>
        </div>

        <button className="add-btn" onClick={handleAddNew}>
          <FiPlus size={16} /> Add New Post
        </button>

      </div>

      {/* Tabs */}
      <div className="tabs-container">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            className={`tab ${activeTab === tab.id ? "active" : ""}`}
            onClick={() => changeTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Job List */}
      <div className="joblist-content">
        {displayJobs.length === 0 ? (
          <div className="empty-state">
            {activeTab === "drafts" && <p>No drafts yet.</p>}
            {activeTab === "archived" && <p>No archived postings.</p>}
            {activeTab === "all" && <p>No job postings found.</p>}
          </div>
        ) : (
          displayJobs.map((job) => (
            <div className="job-row" key={job.id}>
              {/* LEFT */}
              <div className="job-left">
                <h3>{job.jobTitle || job.title}</h3>
                <p className="job-meta">
                  {(job.jobType || job.type || "Job")} ·{" "}
                  {job.location || "Remote"}
                </p>
                <p className="company">
                  {job.companyName || job.company || "Company"}
                </p>
                <p className="date">{getStatusFooterText(job)}</p>

                {/* CENTER */}
                <div className="job-center">
                  {renderStatus(job)}
                  {job.views != null && (
                    <p className="views">
                      <FiEye /> {job.views} Views &nbsp;&nbsp;
                      <button
                        type="button"
                        className="link-text"
                        onClick={() => handleViewApplicants(job)}
                      >{job.applicants || 0} Applicants</button>
                    </p>
                  )}
                </div>
              </div>



              {/* RIGHT */}
              <div className="job-right">
                {renderPrimaryButton(job, handleArchive, handleRestore)}
                <div className="menu-wrapper">
                  <FiMoreVertical
                    className="more-icon"
                    onClick={() =>
                      setOpenMenuId((prev) => (prev === job.id ? null : job.id))
                    }
                  />
                  {openMenuId === job.id && (
                    <div className="job-menu">
                      <button type="button" onClick={() => handleView(job)}>
                        View posting
                      </button>
                      <button type="button" onClick={() => handleEdit(job)}>
                        Edit posting
                      </button>
                      <button type="button" onClick={() => handleReuse(job)}>
                        Reuse posting
                      </button>
                      {job.category === "archived" ? (
                        <button type="button" onClick={() => handleRestore(job.id)}>
                          Restore to active
                        </button>
                      ) : (
                        <button type="button" onClick={() => handleArchive(job.id)}>
                          Move to archive
                        </button>
                      )}
                      <button
                        type="button"
                        className="danger"
                        onClick={() => handleDelete(job.id)}
                      >
                        Delete
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Pagination */}
      {filteredJobs.length > 0 && (
        <div className="pagination">
          <button
            type="button"
            onClick={() => handleChangePage(pageSafe - 1)}
            disabled={pageSafe === 1}
          >
            Prev
          </button>

          {Array.from({ length: totalPages }).map((_, i) => {
            const page = i + 1;
            return (
              <button
                key={page}
                type="button"
                className={page === pageSafe ? "active" : ""}
                onClick={() => handleChangePage(page)}
              >
                {page}
              </button>
            );
          })}

          <button
            type="button"
            onClick={() => handleChangePage(pageSafe + 1)}
            disabled={pageSafe === totalPages}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

/* ---------- helpers ---------- */

function renderPrimaryButton(job, handleArchive, handleRestore) {
  if (job.category === "draft") {
    return <button className="blue-btn">Post draft</button>;
  }

  if (job.category === "archived") {
    return (
      <button className="blue-btn" onClick={() => handleRestore(job.id)}>
        Restore
      </button>
    );
  }

  if (job.status === "expired") {
    return (
      <button className="blue-btn" onClick={() => handleArchive(job.id)}>
        Reuse posting
      </button>
    );
  }

  return <button className="blue-btn">Edit posting</button>;
}

function renderStatus(job) {
  switch (job.status) {
    case "under_review":
      return (
        <p className="status warning">
          {/*⚠️ This job is under review
          //<span>
            //We are reviewing your job posting and will contact you within one business day.
          </span> */}
        </p>
      );
    case "pending_verification":
      return (
        <p className="status warning">
          ⚠️ Pending for company verification
          <span>
            This job is currently inactive, confirm your company to make job visible for
            applicants.
          </span>
        </p>
      );
    case "pending_edits":
      return (
        <p className="status warning">
          ⚠️ Pending for edits
          <span>
            We&apos;ve reviewed your posting and it seems it is still incomplete, please add
            missing information for resubmitting posting to review.
          </span>
        </p>
      );
    case "inactive":
      return (
        <p className="status warning">
          ⚠️ This job is inactive yet
          <span>This job is currently inactive, to start receiving applications.</span>
        </p>
      );
    case "expired":
      return <p className="status muted">Expired</p>;
    default:
      return null;
  }
}

function getStatusFooterText(job) {
  const created = formatDate(job.createdAt);
  switch (job.status) {
    case "under_review":
      return `Under review · Created ${created}`;
    case "pending_verification":
      return `Pending for company verification · Created ${created}`;
    case "pending_edits":
      return `Pending for edits · Created ${created}`;
    case "inactive":
      return `Inactive · Created ${created}`;
    case "expired":
      return `Expired · ${created}`;
    default:
      if (job.category === "draft") return `Draft · Created ${created}`;
      if (job.category === "archived") return `Archived · Created ${created}`;
      return `Created ${created}`;
  }
}

function formatDate(date) {
  if (!date) return "—";
  return new Date(date).toLocaleDateString();
}

export default PostedjobListing;
